import { getConfigForImportedTest, getConfigForMeasuredTest } from 'Components/Worksheets/Config';
import { IConfigFunctionArgs } from 'Components/Worksheets/Core';
import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import getDerivedFromMeasurementsConfig from 'Components/Worksheets/WashWorksheet/derivedFromMeasurementsConfig';
import { WashingProcedure } from 'Components/Worksheets/WashWorksheet/types';
import { IQuantity, isLessThan as quantityIsLessThan, toIQuantity } from 'Data/ViewModels/Core/IQuantity';
import {
  ISieveSize,
  SieveSizeId,
  getById,
  isLessThanOrEqualTo as sieveSizeIsLessThanOrEqualTo,
} from 'Data/ViewModels/Equipment/ISieveSize';
import * as iop from '../../../../../../Lib/Object/Path/Immutable';
import { getMoistureContentPercent } from '../../../../MoistureContentWorksheet/Astm/Config';
import qestIds from '../../../../QestIds';
import getMeasuredUsingConfig from '../../../measuredUsingConfig';

//TODO: Prefix like getConfig does, currently not used inside of other worksheets though.
const mcConfig = (prefix: string) =>
  mergeConfig(
    {
      [`${prefix}.Masses.AssociatedInitialMoistureContent.ExternalTest.Results.MoistureContentPercent`]: {
        format: { nearest: 0.1 },
      },
    },
    getConfigForMeasuredTest(
      qestIds.moistureContent.ASTM_D_2216.rev2019,
      `${prefix}.Masses.AssociatedInitialMoistureContent`,
      { validMethods: ['B'], disabledPaths: ['Preparation.VisualNominalParticleSize', 'Preparation.ExcludedMaterial'] }
    ),
    getConfigForImportedTest(
      qestIds.moistureContent.ASTM_D_2216.rev2019,
      `${prefix}.Masses.AssociatedInitialMoistureContent`
    ),
    getMoistureContentPercent('InitialMoistureContent', `${prefix}.Masses`, 'InitialMoistureContentPreparationMethod')
  );
const getConfig = (prefix: string) =>
  mergeConfig(
    {
      [`${prefix}.Preparation.WashingProcedure`]: {
        options: [
          { label: 'A - Non-cohesive soils', value: WashingProcedure.WashWithPlainWater },
          { label: 'B - Cohesive soils', value: WashingProcedure.WashWithWaterAndAgent },
        ],
      },
      [`${prefix}.Masses.AssociatedInitialMoistureContent.ExternalTest.Results.InitialTareMass`]: {
        uom: 'g',
        format: { nearest: 0.1 },
      },
      [`${prefix}.Masses.AssociatedInitialMoistureContent.ExternalTest.Results.InitialDryMass`]: {
        uom: 'g',
        format: { nearest: 0.1 },
      },
      [`${prefix}.Preparation.SoakingPeriod`]: ({ worksheet }: IConfigFunctionArgs) => {
        const soakingPeriod = iop.get<IQuantity>(worksheet, `${prefix}.Preparation.SoakingPeriod`);
        if (quantityIsLessThan(soakingPeriod, toIQuantity(10, 'min'))) {
          return { uom: 'min', format: { nearest: 1 } };
        }
        return { uom: 'min', format: { nearest: 10 } };
      },

      ...mcConfig(prefix),

      [`${prefix}.Results.PercentPassingWashingSieve`]: ({ worksheet }: IConfigFunctionArgs) => {
        const sieves = iop.get<ISieveSize[]>(worksheet, `${prefix}.Equipment.AllSieveSizes`);
        const id = iop.get<SieveSizeId>(worksheet, `${prefix}.Preparation.MaximumParticleSizeSieveSizeId`);
        const sieve = id && sieves ? getById(sieves, id) : null;
        const s475 = sieves && getById(sieves, '4_75');

        if (sieveSizeIsLessThanOrEqualTo(sieve, s475)) {
          return { format: { nearest: 0.1 } };
        } else {
          return { format: { nearest: 1 } };
        }
      },
    },
    getMeasuredUsingConfig(prefix),
    getDerivedFromMeasurementsConfig(prefix),
    {
      [`${prefix}.Equipment.InitialBalance`]: { defaultReadability: 0.1, defaultUom: 'g' },
      [`${prefix}.Equipment.WashedBalance`]: { defaultReadability: 0.1, defaultUom: 'g' },
    }
  );

export { getConfig };

export default {
  [qestIds.wash.ASTM_D1140.rev2017]: getConfig,
};
